import { fragment } from "~/util/dom";
import { description } from "~/util/providers/poiagg";
import { CONFIG } from "~/config";
import { createMarkerInfo, createMarkerInfoPlace } from "~/ui/markerinfo";
import { coordsToString } from "~/util/mirek";
import { iframeAnalyticsLog } from "~/util/analyticsAction";
import { store } from "~/state/store";
import { ROUTE_CONST } from "~/route/const";
import { openAdminDetail } from "~/util/userweb";
import { saveHistory } from "~/util/providers/history";
import Scene from "~/scene";
import { firmStats, isFirmFromPoi } from "~/util/review";
import { ISubscriptionWithDescription } from "~/util/providers/share-position/interfaces";
import { createSubscriptionTextInfo } from "~/ui/share-position/share-position-subscription-text";
import { createSubscriptionTextInfo as createSubscriptionTextInfo2 } from "~/ui/share-position/share-position-subscription-text2";
import { _ } from "~/i18n";
import { IWasmCustomData } from "~/interfaces";

function popupfirmStats(type, data, specParam) {
	switch (type) {
		case "route":
		case "detail":
			firmStats("firmy-vizitka-akce", data, specParam);
			break;
		case "desc":
			firmStats("firmy-vizitka-doruceni", data, specParam);
			break;
		default:
			//
	}
};

// popup dle source a id vedouci na detail POIe
export async function setPOIPopupContent(source: string, id: number, search: boolean): Promise<DocumentFragment> {
	const container = fragment();
	const descriptionResponse = await description([{ source, id }], {
		fetchPhoto: true,
		ratios: ["1x1"],
		lang: CONFIG.langPriority,
		query: Mapy.getComponent("search").getQuery(),
		reviews: true,
		wikimedia: true,
	});
	const poi = descriptionResponse.poi.length ? descriptionResponse.poi[0] : null;

	if (!poi) {
		return container;
	}

	const isDMorUM = Mapy.getComponent("distanceMeter").isActive() || Mapy.getComponent("userMarks").isActive() || poi.source === "gr";
	// obsah
	const markerInfo = createMarkerInfo({
		poi,
		routeBtnCb: async () => {
			//FIXME pokud je otevreny imageuploader ma to tak zustat
			if (Mapy.getComponent("imageUploader").isActive()) {
				return;
			}

			if (CONFIG.inFrame) {
				iframeAnalyticsLog({
					type: "click-back",
					referrer: document.referrer,
					form: "other",
				});
				window.open(`${CONFIG.mapyURL}/${store.getState().map.mapset}?planovani-trasy&y=${poi.mark.lat}&x=${poi.mark.lon}&z=18&rc=${coordsToString([[poi.mark.lon, poi.mark.lat]])}&rs=&rs=${poi.source}&ri=&ri=${poi.id}&mrp={"c"%3A111}`);
			} else {
				const route = Mapy.getComponent("route");

				if (!Mapy.CML.state.route?.items?.length) {
					Mapy.CML.state = {
						route: {
							params: {
								criterion: poi.source === "pubt" ? 200 : 111,
								type: poi.source === "pubt" ? ROUTE_CONST.TYPE_PUBT : ROUTE_CONST.TYPE_CAR,
							},
						},
					};
				}

				await route.addItem({
					source: poi.source,
					position: Mapy.getComponent("route").isActive() ? ROUTE_CONST.position.start : ROUTE_CONST.position.end,
					id: poi.id,
					name: poi.title,
					coords: Scene.coordsFromWGS84(poi.mark.lon, poi.mark.lat),
					desc: poi.multiTitle ? poi.multiTitle.slice(1).join(", ") : poi.title,
					..."typeId" in poi ? { typeId: poi.typeId } : {},
				});
			}

			if (isFirmFromPoi(poi)) {
				popupfirmStats("route", poi, { placeId: 9, typeId: 3 });
			}

			if (!CONFIG.inFrame) {
				Mapy.getComponent("history").save();
			}
		},
	});

	// click eventy
	// pro detail nechceme otevrit znovu detail
	if (!isDMorUM) {
		markerInfo.info.addEventListener("click", event => {
			//FIXME pokud je otevreny imageuploader ma to tak zustat
			if (Mapy.getComponent("imageUploader").isActive()) {
				return;
			}

			if (CONFIG.inFrame) {
				iframeAnalyticsLog({
					type: "click-back",
					referrer: document.referrer,
					form: "other",
				});
				window.open(`${CONFIG.mapyURL}/${store.getState().map.mapset}?source=${poi.source}&id=${poi.id}`);
			} else if (store.getState().map.mapset === "uzavirky" && poi.past) { // klik na minule uzavirky otevre detail v poiadminu
				openAdminDetail(poi.source, poi.id as number);
			} else {
				const state = {
					source: poi.source,
					id: poi.id,
					manual: true,
					show: false,
					...Mapy.getComponent("search").isActive()
						? { search: Mapy.getComponent("detail").getSuggestConf() }
						: {},
				};

				if (search) {
					const filters = Mapy.getComponent("search").getFilters();
					const logObj = {
						/* eslint-disable camelcase */
						search_type: "searchmap",
						...Object.keys(filters).length
							? {
								filter_id: "",
								filter_type: "",
							}
							: {},
						/* eslint-enable camelcase */
					};

					if (Object.keys(filters).length) {
						for (const filterKey in filters) {
							if (Object.prototype.hasOwnProperty.call(filters, filterKey)) {
								/* eslint-disable camelcase */
								logObj.filter_id += (logObj.filter_id === "" ? "" : ",") + filters[filterKey].id;
								logObj.filter_type += (logObj.filter_type === "" ? "" : ",") + filters[filterKey].type;
								/* eslint-enable camelcase */
							}
						}
					}
					Mapy.Util.analyticsSearchSelection(logObj, poi);
				}

				if (!Mapy.Util.linkToNewWindow(event)) {
					event.preventDefault();

					Mapy.getComponent("detail").setState(state).then(() => {
						const { user } = store.getState().user;

						saveHistory(user, {
							title: poi.title,
							source: "web",
							type: "poi",
							data: {
								entitySource: poi.source,
								entityId: poi.id as number,
								lon: poi.mark.lon,
								lat: poi.mark.lat,
							},
						}).then(() => {}, () => {});
						Mapy.getComponent("history").save();
					}, () => {});

					if (Mapy.Util.isSmallResolution()) {
						Mapy.getComponent("layout").setWidth(1);
					}
				}
			}

			if (isFirmFromPoi(poi)) {
				popupfirmStats("detail", poi, { placeId: 9, typeId: 7 });
			}
		});
	}

	container.appendChild(markerInfo.info);

	if (!isDMorUM) {
		container.append(markerInfo.seperatorPart, markerInfo.buttonPart);
	}

	if (isFirmFromPoi(poi) && poi.paid) {
		popupfirmStats("desc", poi, { placeId: 9 });
	}

	return container;
}

// popup veci z MM
export async function setMMPopupContent(item: IWasmCustomData["mmItem"], showParentInfo: boolean, clickCallback: (event: MouseEvent, item: IWasmCustomData["mmItem"]) => void): Promise<DocumentFragment> {
	const container = fragment();

	await Promise.resolve();

	// obsah
	const markerInfo = createMarkerInfoPlace({
		item,
		routeBtnCb: item.type === "entity"
			|| item.type === "point"
			? async () => {
				//FIXME pokud je otevreny imageuploader ma to tak zustat
				if (Mapy.getComponent("imageUploader").isActive()) {
					return;
				}

				const route = Mapy.getComponent("route");

				if (!Mapy.CML.state.route?.items?.length) {
					Mapy.CML.state = {
						route: {
							params: {
								criterion: item.source === "pubt" ? 200 : 111,
								type: item.source === "pubt" ? ROUTE_CONST.TYPE_PUBT : ROUTE_CONST.TYPE_CAR,
							},
						},
					};
				}

				await route.addItem({
					source: item.type === "point" ? "coor" : item.source,
					position: Mapy.getComponent("route").isActive() ? ROUTE_CONST.position.start : ROUTE_CONST.position.end,
					id: item.type === "point" ? `${item.mark.lon},${item.mark.lat}` : item.source_id,
					name: item.title,
					coords: Scene.coordsFromWGS84(item.mark.lon, item.mark.lat),
					desc: item.subtitle,
					...item.usertitle ? { usertitle: item.usertitle } : {},
					favoriteId: item.id,
					..."poi_type_id" in item ? { typeId: item.poi_type_id } : {},
				});

				!CONFIG.inFrame && Mapy.getComponent("history").save();
			}
			: null,
		url: `${CONFIG.mapyURL}/?dim=${item.id}`,
		showParentInfo,
	});

	// click eventy
	markerInfo.info.addEventListener("click", event => {
		if (!Mapy.Util.linkToNewWindow(event)) {
			event.preventDefault();
			clickCallback(event, item);
		}
	});

	container.appendChild(markerInfo.info);

	if (item.type === "entity" || item.type === "point") {
		container.appendChild(markerInfo.seperatorPart);
		container.appendChild(markerInfo.buttonPart);
	}

	return container;
}

// popup pro spoj v hromadne doprave
export async function setPublicTransportLinePopupContent(): Promise<DocumentFragment> {
	const container = fragment();

	container.textContent = "Public Transport Line popup";
	await Promise.resolve();

	return container;
}

// popup pro sdilenou polohu
export async function setSharedLocationPopupContent(subscriptionId: string): Promise<DocumentFragment> {
	const container = fragment();
	const { sharePosition } = store.getState();
	const subscription: ISubscriptionWithDescription = sharePosition.subscriptions.find(sub => sub.subscriptionId === subscriptionId);

	await Promise.resolve();

	if (!subscription) {
		return container;
	}

	if (Mapy.CUS.userweb?.generalSharePosition) {
		container.appendChild(createSubscriptionTextInfo2(subscription, CONFIG.defaultLang, _));
	} else {
		container.appendChild(createSubscriptionTextInfo(subscription, CONFIG.defaultLang, _));
	}

	return container;
}
